import { connect } from 'react-redux';
import idx from 'idx';
import ImageNameTile from 'focus_groups/components/image_name_tile';

const mapStateToProps = (state, { item }) => {
  const selected = idx(state, _ => _.project.focusGroups.viewState.selected) || [];

  return {
    selected: selected.includes(item.revisions[0].id)
  };
}

export default connect(mapStateToProps)(ImageNameTile);



// WEBPACK FOOTER //
// ./focus_groups/containers/image_name_tile.js